import {
  DeleteMeasurementsResponseSchema,
  type DeleteMeasurementsRequest,
  type DeleteMeasurementsResponse,
} from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { invalidateMetersQueries } from '../../utils/query-invalidation';

export function useDeleteMeasurements(
  options?: UseMutationOptions<
    DeleteMeasurementsResponse,
    unknown,
    DeleteMeasurementsRequest['measurementIds']
  >,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (measurementIds) => {
      const api = getPrivateApi();

      const deleteMeasurementsResponse = await api.deleteMeasurements({
        deleteMeasurementsRequest: { measurementIds },
      });

      return DeleteMeasurementsResponseSchema.parse(deleteMeasurementsResponse);
    },
    onSuccess: async () => {
      await invalidateMetersQueries(queryClient);
    },
    ...options,
  });
}
